export default "__VITE_ASSET__fb1c7747__"